/** A/A only: this module never decides whether a widget is shown. */
export const AA_EXPERIMENT_ID = "parikara-aa-v1";
export function makeExperimentEnrollment(
  config: { id: string; mode: string } | null | undefined,
  account: () => string | null,
  eligible: () => boolean,
  presence: (account: string) => void,
) {
  const enrolled = new Set<string>();
  const enabled = config?.mode === "aa" && config.id === AA_EXPERIMENT_ID;
  const tick = (heartbeat = false): void => {
      const user = account();
      if (!enabled || !user || !eligible()) return;
      const fresh = !enrolled.has(user);
      enrolled.add(user);
      if (fresh || heartbeat) presence(user);
    };
  return {
    tick,
    experimentFor(user: string): string | null {
      // Stamp the first eligible event, even before the periodic enrollment tick.
      // tick marks enrollment before presence calls back into sendEvent.
      if (user === account() && !enrolled.has(user)) tick();
      return enabled && enrolled.has(user) ? AA_EXPERIMENT_ID : null;
    },
  };
}
